export const WEBVIEW_MESSAGES = {
    "PEOPLE_ADDED_SUCCES" : "People added successfully",
    "PERMISSION_UPDATED_SUCCESS" : "Permission updated successfully",
    "ALL_ITEMS_COPIED_SUCESS" : "Selected item(s) have been copied successfully",
    "NOT_ENOUGH_FREE_SPACE" : "You don't have enough space to complete this action",
    "ALREADY_GRANTED_ACCESS" : "The access for this object is already granted.",
    "LOGIN_REQUIRED_SHARELINK" : "Login is required to access the share link",
    "OBJECT_KEY_NOT_PART_INPUT_SHARE" : "Object Key is not part of input share.",
    "CONTACT_SHAREOWNER_REQURED_PERMISSION" : "Contact Share Owner to get the required permission to perform operation.",
    "SHARE_USER_NOT_MAPPED_SHARELINK" : "Share User is not mapped with Shared Link.",
    "SHARE_USER_NO_ACCESS" : "Share User doesn't have either of Add/Edit access.",
    "GRANT_ACCESS_ERROR" : "Something Went Wrong while granting access.",
    "REQUEST_ACCESS_ERROR":"Something went wrong while requesting access.",
    "SHARE_DEFAULT_ERROR" : "Something went wrong. Please try again later",
    "SOME_ITEMS_COPIED_SUCESS" : "Some of the item(s) haven't been copied.",
    "NONE_COPIED":"None of the item(s) have been copied. Please try again"
}